// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__DB8xU","main":"Page_main__HYTCJ","grid":"Page_grid__U7Nx0"};